<template>
  <div 
    class="card"
    :style="{
      backgroundPosition: -width * Number(size) + 'px ' + -height * Number(color) + 'px',
      width: width + 'px',
      height: height + 'px',
      backgroundSize: 9 * width + 'px'
    }"
  >
  </div>  
</template>

<script>
export default {
  name: 'Card',
  props: {
    color: Number,
    size: Number,
    width: {
      type: Number,
      default: 156
    }
  },
  computed: {
    height() {
      return (320 / 208) * this.width;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.card {
  border: 0.5px #000 solid;
  border-radius: 10px;
  background: white;
  background-image: url("../assets/jasskarten.png");
  background-repeat: no-repeat;
  z-index: 2;
}
.card:hover {
}
</style>
